import type { IntlShape } from 'react-intl';

/**
 * Safely format a dynamic (data-derived) message id.
 *
 * react-intl's `formatMessage` throws (an `id` must be provided invariant) when the id is falsy
 * (undefined / null / empty) — which crashes the whole page (blue error screen). A merely missing
 * translation does NOT throw; it just falls back to the id. This helper guards the falsy-id case
 * and uses `defaultMessage` (the id itself by default) as the visible fallback, so a missing or
 * empty translation degrades gracefully instead of breaking the UI.
 */
export const safeFormatMessage = (
    formatMessage: IntlShape['formatMessage'],
    id: string | null | undefined,
    defaultMessage?: string,
): string => (id ? String(formatMessage({ id, defaultMessage: defaultMessage ?? id })) : (defaultMessage ?? ''));
